import { View, Text, StyleSheet } from 'react-native';
import React, { useEffect, useState } from 'react';
import { useQuery } from "@apollo/client";

import Constants from '../constants';
import { GET_USERS } from './../graphql/queries';
import NewButton from '../components/NewButton';
import UserTable from '../components/User/UserTable';
import NewUserModal from '../components/User/NewUserModal';
import StaffSeatsSummary from '../components/User/StaffSeatsSummary';
import BasicLayout from '../components/Shared/BasicLayout';
import { resolveSeatPlanId } from '../utils/staffSeats';
import { useSubscription } from '../contexts/subscription';


export default function Users(): JSX.Element {
  const [showNewUser, setShowNewUser] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<number>(0);

  const { data: usersData, refetch: refetchUsers } = useQuery(GET_USERS, {
    fetchPolicy: 'network-only',
  });

  const subscription = useSubscription();
  const teamUsed =
    usersData?.users?.users?.filter((u: { wpAdmin?: boolean }) => !u.wpAdmin).length ?? 0;
  const seatPlanId = subscription.status === 'ready' && subscription.planId
    ? subscription.planId
    : resolveSeatPlanId();

  useEffect(() => {
    refetchUsers();
  }, [refresh]);

  const onOpenNewUser = () => {
    setShowNewUser(true)
  }

  const onCloseNewUser = () => {
    setShowNewUser(false)
  }

  const onRefresh = () => {
    setRefresh(refresh + 1)
  }

  return (
    <BasicLayout style={styles.container} active={'/users'}>
      <View style={styles.header}>
        <Text style={styles.heading}>Users</Text>
        <NewButton name="User" onClick={onOpenNewUser} />
      </View>

      <StaffSeatsSummary teamUsed={teamUsed} planId={seatPlanId} />

      <UserTable refresh={refresh} />

      <NewUserModal
        isVisible={showNewUser}
        onClose={onCloseNewUser}
        onCreated={onRefresh}
        teamUsed={teamUsed}
        planId={seatPlanId}
      />
    </BasicLayout>
  )

  // return (
  //   <View style={styles.container}>
  //     <Navbar active={'/users'} />
  //     <View style={{ flex: 1, padding: 25 }}>
  //       <UserDetailsModal isVisible={showUserDetails} user={state.user ? state.user : undefined} onClose={closeUserDetails} />
  //       <DashboardNav name={state.user?.name ?? ''} dropOptions={[{ id: 'users', label: 'Users', value: 'users' }, { id: 'account', label: 'Account', value: 'account' }]} actionOne={state.user?.wpAdmin} onAction={onDashboardAction} onDropdownSelect={onDashboardAction} />
  //
  //       <View style={{ marginTop: 25, padding: 10 }}>
  //         <View style={styles.header}>
  //           <Text style={styles.heading}>Users</Text>
  //           <NewButton name="User" onClick={onOpenNewUser} />
  //         </View>
  //
  //         <UserTable refresh={refresh} />
  //
  //         <NewUserModal isVisible={showNewUser} onClose={onCloseNewUser} onCreated={onRefresh} />
  //       </View>
  //     </View>
  //   </View>
  // );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignContent: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'row',
    backgroundColor: Constants.colors.backgroundLight,
  },
  campaign: {
    flexDirection: 'row',
    margin: 25,
    paddingLeft: 35,
    borderRadius: 15,
    backgroundColor: '#FFF',
    justifyContent: 'space-evenly',
  },
  heading: {
    fontSize: 30,
    color: Constants.colors.blue,
    fontFamily: 'GothamBold',
    marginRight: 10
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'default',
    marginBottom: 50,
    marginTop: 5
  },
});
